import { useEffect, useState } from "react";

import {
  type AppLauncherManifestEntry,
  loadAppLauncherManifest,
  resolveAuthAppUrl,
} from "nazare-ui/utils";

export function useAppLauncherManifest() {
  const [manifest, setManifest] = useState<
    readonly AppLauncherManifestEntry[]
  >([]);

  useEffect(() => {
    let active = true;

    void (async () => {
      try {
        const entries = await loadAppLauncherManifest({
          authAppUrl: resolveAuthAppUrl(
            window.location.href,
            import.meta.env.VITE_NAZARE_AUTH_APP_URL,
          ),
        });
        if (active) setManifest(entries);
      } catch {
        if (active) setManifest([]);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return manifest;
}
